import { createContext, useContext, useState, type ReactNode } from "react";
import {
  SUPPORTED_LANGUAGES,
  LANGUAGE_STORAGE_KEY,
  type Language,
} from "@/constants/languages";
import { getActiveLanguage } from "@/lib/utils";

const MANUAL_FLAG_KEY = "language-manually-set";

interface LanguageContextValue {
  language: string;
  setLanguage: (code: string) => void;
  languages: Language[];
}

const LanguageContext = createContext<LanguageContextValue | undefined>(
  undefined,
);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [language] = useState<string>(getActiveLanguage);

  const setLanguage = (code: string) => {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
    localStorage.setItem(MANUAL_FLAG_KEY, "true");
    window.location.reload();
  };

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage, languages: SUPPORTED_LANGUAGES }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
